<template>
  <li class="nav-item dropdown">
    <a
      id="navbarDropdown"
      class="nav-link"
      href="#"
      role="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      <i :class="'far '+icon+' fa-2x'"></i>
      <span
        class="badge badge-pill badge-danger badge-up"
        v-if="messages.length > 0">{{ messages.length }}</span>
    </a>

    <ul class="dropdown-menu dropdown-menu-messages dropdown-menu-right messages shadow py-0" role="menu">
      
    <div class="pt-2 pb-0">
      <li class="scrollable-container media-list container-fluid pr-0" style="max-height:22.3rem; overflow-y: auto;">
        <ul class="list-group container-fluid">
            <button v-for="(message, index) in messages" :key="index" @click="openUrl(message)" class="messages-row text-left">
              <div class="media d-flex align-items-start">
                <div class="media-body px-2 pt-1">
                  <div class="row">
                    <div class="col pr-0">   
                        <p class="m-0">
                          <span class="message-sender">{{message.sender.name+' '+message.sender.surname}}</span>
                        </p>
                        <div class="message-message">
                          {{ truncate(message.message,80) }}
                        </div>
                        <div class="message-time"><timeago class="ml-0"
                            :datetime="message.created_at"
                            :auto-update="60"></timeago></div>
                    </div>
                  </div>
                </div>
              </div>          
          </button>
      </ul>
    </li>

          <li>
            <div class="border-top mt-2" v-if="messages.length > 0"></div>
            <div class="text-center see-all-messages mt-0 mb-2 pt-0">
              <div v-if="messages.length == 0">No new {{category}}</div>
              <div v-if="messages.length > 0" class="pt-1"></div>
              <div><a :href="'/'+category"><strong>See all {{category}}</strong></a></div>
            </div>
          </li>
        </div>
      
    </ul>
  </li>
</template>

<script>
export default {
  props: ["user","icon","category","event","update"],

  data() {
    return {
    messages: [],
    available: false,
    };
  },

    created() {
    this.getMessages();

    Echo.private(this.category+'_' + this.user.id)
      .listen(this.event, (e) => {
        
        this.getMessages();

        this.available = true;
        setTimeout(() => {
          this.available = false;
        }, 3000);
      })
      .listen(this.update, (e) => {
        this.getMessages();
      });
      

  },

  methods: {
    getMessages() {
      axios.post('/'+this.category+'/get', {status: 0}).
      then((response) => {
        this.messages = response.data;
      });
    },

    Mark(message, new_status) {

      axios
        .post('/'+this.category+'/mark', {id: message.id, status: new_status})
        .then((response) => {
            console.log(response.data);
        });
    },

    openUrl(message) {

      this.Mark(message, 1);

      var target = '_self';
      var url = '';

      if (this.category=='messages') { var tabIndex = 2; }
      else { var tabIndex = 0; }

      if (message.url) url = message.url;
      if (message.target) target = message.target;

      if (url != '') {

        window.open(url+ '/'+tabIndex, target);

      }

    },
  },
};
</script>

<style scoped>
.message-sender{font-weight:bold;color:#414141;font-size: 0.9rem;}
a.mark_icon:link, a.mark_icon:visited { color: #2b2b2b;}
a.mark_icon:hover { color: #38c172;}
a.mark_icon:active { color: #2b2b2b;}
button.messages-row.text-left:hover{background:#dfdfdf;}
button.messages-row.text-left {border:1px solid rgb(230, 230, 230);border-radius:5px; margin-bottom:5px;padding-right:10px; background:#fff !important}
a.d-flex {text-decoration:none;}
a.d-flex:hover {color:#fff !important; }
.dropdown-menu-right.messages { 
    width: 20rem; 
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 3px;
  position: relative;
  top: -1.2rem;
  left: -1rem;
}

.btn-light:hover {
  color: #2b9ade;
}
.btn-light:active {
  color: #176a9e;
}
.btn-light {
  color: #44a6e2;
}
a.old-messages {
  margin-right: 1.9rem;
}
h4.dark-blue {
  padding-left: 0.4rem;
}
div.media-body.no-padding {
  padding: 0;
}
h5.light-blue {
  width: max-content;
  float: right;
}
h5.light-blue:hover {
  cursor: pointer;
}
.no-new {
  padding-left: 0 !important;
}
.check-mark {
  position: relative;
  top: -0.05rem;
  margin-right: 0.5rem !important;
}
.notify-container {
  border-bottom: 0px solid #e8ecf1;
}
.dark-blue {
  color: #101a34;
}
.light-blue {
  color: #2b9ade;
}

.header-navbar .navbar-container ul.navbar-nav li {
  line-height: 1.5;
  list-style: none;
}

.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl,
.navbar .container-xxl {
  align-items: normal;
}

.header-navbar .navbar-container .dropdown-menu-media {
  width: 30rem;
}

.header-navbar .navbar-container .dropdown-menu-media .dropdown-menu-footer {
  border-top: 0;
}

.header-navbar
  .navbar-container
  ul.navbar-nav
  li.dropdown-cart
  .dropdown-menu.dropdown-menu-right,
.header-navbar
  .navbar-container
  ul.navbar-nav
  li.dropdown-message
  .dropdown-menu.dropdown-menu-right {
  border: 1px solid #cad3dd;
  padding: 1rem 0.5rem;
}

.header-navbar .navbar-container .dropdown-menu-media .media-list .media {
  padding: 0;
}

.media-body {

  padding: 0.4rem 0;
}

.media-list .media .media-left {
  margin-right: 0;
}

svg.tick {
  height: 1.5rem;
  width: 1.5rem;
  display: inline-block;
}
.message-subject {
  font-size: 1.6em;
  color: #101a34;
  font-weight: bold;
}
.message-message {
  font-size: 0.9rem;
  color: #5e6577;
  padding-left: 0;
  line-height: 1rem;
}
.header-navbar
  .navbar-container
  ul.navbar-nav
  li.dropdown-message
  .media-body
  .media-heading {
  color: #101a34;
  margin-bottom: 0;
  line-height: 1.2;
  font-size: 1rem;
  padding-left: 0;
}

.media-list .media {
  padding: 0;
}

.message-time {
  font-size: 0.8em;
}

time {
    color: #272727;
}

</style>
